// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__h9jD1"};